import { axiosRequest, axiosRequestData } from "../helpers/axios";
import {
  AccountBootstrapResponse,
  ManageProfilePayload,
} from "../interfaces/account";

function pickBootstrapPayload(data: any): AccountBootstrapResponse {
  const payload = data?.data ?? data;
  return {
    profile: payload?.profile ?? {
      email: "",
      first_name: "",
      last_name: "",
      user_height: "",
      user_dob: "",
      user_hand: "",
      user_handicap: "",
      avatar: "",
    },
    tabs: Array.isArray(payload?.tabs) ? payload.tabs : [],
  };
}

export async function getAccountBootstrap(): Promise<AccountBootstrapResponse> {
  const res = await axiosRequest("GET", "/wp-json/pg/v2/account");
  return pickBootstrapPayload(res?.data);
}

export async function updateAccountProfile(payload: ManageProfilePayload) {
  return axiosRequestData("POST", "/wp-json/pg/v1/user/edit", payload);
}

export async function updateAccountPassword(password: string, password2: string) {
  return axiosRequestData("POST", "/wp-json/pg/v1/user/password", { password, password2 });
}

export async function updateAccountAvatar(base64: string) {
  return axiosRequestData("POST", "/wp-json/pg/v1/user/avatar", { avatar: base64 });
}
